import { useOnlineStatus } from '../lib/useOnlineStatus';

/**
 * A small, always-visible online/offline badge for the POS toolbar.
 * Deliberately separate from `PosStatusChip`, which only renders in local
 * mode and folds connectivity into a longer cashier-facing sync message
 * (docs/offline/PHASE-8-ARCHITECTURE.md). This one renders in every
 * `posDataMode` - even a browser that has never enrolled in offline mode
 * (still on `RemoteDataSource`) benefits from a plain "the connection just
 * dropped" signal, since `App.tsx`'s automatic offline-unlock routing
 * already reacts to the same `online`/`offline` browser events this
 * component displays; it just never shows a matching chip in the POS
 * toolbar today.
 */
export function ConnectivityIndicator() {
  const online = useOnlineStatus();

  return (
    <span
      className={`chip ${online ? 'ok' : 'warn'}`}
      title={online ? 'Connected to the network.' : 'No network connection right now.'}
    >
      {online ? 'Online' : 'Offline'}
    </span>
  );
}
